<div class="skeleton skeleton--animated">
</div>
